import { render, staticRenderFns } from "./Lgx279928282177077248.vue?vue&type=template&id=5c8dee84&scoped=true&"
import script from "./Lgx279928282177077248.vue?vue&type=script&lang=js&"
export * from "./Lgx279928282177077248.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8dee84",
  null
  
)

export default component.exports